/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InvestmentComponentViewModel } from './InvestmentComponentViewModel';
import {
    InvestmentComponentViewModelFromJSON,
    InvestmentComponentViewModelFromJSONTyped,
    InvestmentComponentViewModelToJSON,
} from './InvestmentComponentViewModel';
import type { InvestmentFundViewModel } from './InvestmentFundViewModel';
import {
    InvestmentFundViewModelFromJSON,
    InvestmentFundViewModelFromJSONTyped,
    InvestmentFundViewModelToJSON,
} from './InvestmentFundViewModel';

/**
 * 
 * @export
 * @interface InvestmentPlanViewModel
 */
export interface InvestmentPlanViewModel {
    /**
     * 
     * @type {string}
     * @memberof InvestmentPlanViewModel
     */
    investmentPlanNumber: string;
    /**
     * 
     * @type {string}
     * @memberof InvestmentPlanViewModel
     */
    investmentPlanName?: string;
    /**
     * 
     * @type {Date}
     * @memberof InvestmentPlanViewModel
     */
    inceptionDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof InvestmentPlanViewModel
     */
    investmentType: string;
    /**
     * 
     * @type {number}
     * @memberof InvestmentPlanViewModel
     */
    totalMarketValue: number;
    /**
     * 
     * @type {Array<InvestmentFundViewModel>}
     * @memberof InvestmentPlanViewModel
     */
    investmentFunds: Array<InvestmentFundViewModel>;
    /**
     * 
     * @type {Array<InvestmentComponentViewModel>}
     * @memberof InvestmentPlanViewModel
     */
    components: Array<InvestmentComponentViewModel>;
    /**
     * 
     * @type {number}
     * @memberof InvestmentPlanViewModel
     */
    portfolioPercentage: number;
    /**
     * 
     * @type {boolean}
     * @memberof InvestmentPlanViewModel
     */
    isRetirementProduct: boolean;
}

/**
 * Check if a given object implements the InvestmentPlanViewModel interface.
 */
export function instanceOfInvestmentPlanViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "investmentPlanNumber" in value;
    isInstance = isInstance && "investmentType" in value;
    isInstance = isInstance && "totalMarketValue" in value;
    isInstance = isInstance && "investmentFunds" in value;
    isInstance = isInstance && "components" in value;
    isInstance = isInstance && "portfolioPercentage" in value;
    isInstance = isInstance && "isRetirementProduct" in value;

    return isInstance;
}

export function InvestmentPlanViewModelFromJSON(json: any): InvestmentPlanViewModel {
    return InvestmentPlanViewModelFromJSONTyped(json, false);
}

export function InvestmentPlanViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentPlanViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'investmentPlanNumber': json['InvestmentPlanNumber'],
        'investmentPlanName': !exists(json, 'InvestmentPlanName') ? undefined : json['InvestmentPlanName'],
        'inceptionDate': !exists(json, 'InceptionDate') ? undefined : (new Date(json['InceptionDate'])),
        'investmentType': json['InvestmentType'],
        'totalMarketValue': json['TotalMarketValue'],
        'investmentFunds': ((json['InvestmentFunds'] as Array<any>).map(InvestmentFundViewModelFromJSON)),
        'components': ((json['Components'] as Array<any>).map(InvestmentComponentViewModelFromJSON)),
        'portfolioPercentage': json['PortfolioPercentage'],
        'isRetirementProduct': json['IsRetirementProduct'],
    };
}

export function InvestmentPlanViewModelToJSON(value?: InvestmentPlanViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'InvestmentPlanNumber': value.investmentPlanNumber,
        'InvestmentPlanName': value.investmentPlanName,
        'InceptionDate': value.inceptionDate === undefined ? undefined : (value.inceptionDate.toISOString()),
        'InvestmentType': value.investmentType,
        'TotalMarketValue': value.totalMarketValue,
        'InvestmentFunds': ((value.investmentFunds as Array<any>).map(InvestmentFundViewModelToJSON)),
        'Components': ((value.components as Array<any>).map(InvestmentComponentViewModelToJSON)),
        'PortfolioPercentage': value.portfolioPercentage,
        'IsRetirementProduct': value.isRetirementProduct,
    };
}

